import { render, staticRenderFns } from "./ProductionDeliveryView.vue?vue&type=template&id=2bcec2c3&scoped=true"
import script from "./ProductionDeliveryView.vue?vue&type=script&lang=js"
export * from "./ProductionDeliveryView.vue?vue&type=script&lang=js"
import style0 from "./ProductionDeliveryView.vue?vue&type=style&index=0&id=2bcec2c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcec2c3",
  null
  
)

export default component.exports